import { company } from '../data/siteData'

const FORM_ENDPOINT = `https://formsubmit.co/ajax/${encodeURIComponent(company.email)}`

function formatProductValue(product) {
  if (Array.isArray(product)) {
    return product.join(', ')
  }

  return product?.trim() || 'Not specified'
}

function buildQuotePayload(formData) {
  return {
    form_type: 'Quote Request',
    name: formData.name.trim(),
    email: formData.email.trim(),
    phone: formData.phone.trim(),
    product: formatProductValue(formData.product),
    quantity: formData.quantity?.trim() || 'Not specified',
    grade: formData.grade?.trim() || 'Not specified',
    packing: formData.packing?.trim() || 'Not specified',
    delivery_location: formData.deliveryLocation?.trim() || 'Not specified',
    additional_requirements: formData.message?.trim() || 'Not specified',
    _subject: `Quote request from ${formData.name.trim()} - Torbit Metals`,
    _template: 'table',
    _captcha: 'false',
  }
}

function buildInquiryPayload(formData) {
  return {
    form_type: 'General Inquiry',
    name: formData.name.trim(),
    email: formData.email.trim(),
    phone: formData.phone.trim(),
    subject: formData.subject?.trim() || 'General inquiry',
    message: formData.message.trim(),
    _subject: `General inquiry from ${formData.name.trim()} - Torbit Metals`,
    _template: 'table',
    _captcha: 'false',
  }
}

export async function submitContactForm(formData, formType = 'inquiry') {
  const payload = formType === 'quote' ? buildQuotePayload(formData) : buildInquiryPayload(formData)

  const response = await fetch(FORM_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(payload),
  })

  let data = {}
  try {
    data = await response.json()
  } catch {
    // FormSubmit may return non-JSON on network issues.
  }

  if (!response.ok) {
    throw new Error(data.message || 'Unable to send your request. Please try again.')
  }

  return data
}

export function isContactFormConfigured() {
  return Boolean(company.email)
}
